import { createSelector } from "@reduxjs/toolkit";
import moment from "moment";

import { OrganizationProjectStatusesTypes } from "Api/organizations/projects/OrganizationProjects.types";

import type { RootState } from "Store/configureStore";

export const organizationProjectsStateSelector = (state: RootState) =>
  state.organizationProjects;

export const isOrganizationProvisioningProject = createSelector(
  organizationProjectsStateSelector,
  (_: RootState, params: { organizationId: string }) => params,
  (state, { organizationId }) =>
    state.organizationsProvisioningProject.find(id => id === organizationId)
);

export const loadingOrganizationProjectsSelector = createSelector(
  organizationProjectsStateSelector,
  organizationProjectsState => organizationProjectsState.loading
);

export const organizationProjectSelector = createSelector(
  organizationProjectsStateSelector,
  (_: RootState, params: { organizationId: string; projectId: string }) =>
    params,
  (state, { organizationId, projectId }) =>
    state.data?.[organizationId]?.[projectId]
);

export const organizationProvisioningProject = createSelector(
  organizationProjectsStateSelector,
  (_: RootState, params: { organizationId: string }) => params,
  (state, { organizationId }) =>
    Object.values(state.data?.[organizationId] ?? {})
      .sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      )
      .find(
        project =>
          project.status === OrganizationProjectStatusesTypes.requested &&
          moment(project.created_at).diff(moment(), "minutes") >= -15
      )
);

export const organizationProvisioningFailureProject = createSelector(
  organizationProjectsStateSelector,
  (_: RootState, params: { organizationId: string }) => params,
  (state, { organizationId }) =>
    Object.values(state.data?.[organizationId] ?? {}).find(
      project => project.status === OrganizationProjectStatusesTypes.failed
    )
);
